/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Player_Not_On_ArchonInputs */



/**
* | output |
* | --- |
* | "Player not on Archon?" |
*
* @param {Add_Player_Not_On_ArchonInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const add_player_not_on_archon = /** @type {((inputs?: Add_Player_Not_On_ArchonInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Player_Not_On_ArchonInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joueur absent d'Archon ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Jugador no está en Archon?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogador não está no Archon?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocatore non su Archon?")
	return /** @type {LocalizedString} */ ("Player not on Archon?")
});